// Generic analytics wrapper. No tracking IDs are configured — wire this
// up to Google Analytics, GTM, or another platform by implementing
// `dispatch` once NEXT_PUBLIC_GA_ID / NEXT_PUBLIC_GTM_ID are set.

export type AnalyticsEvent =
  | "hero_cta_click"
  | "product_card_click"
  | "buy_now_click"
  | "whmcs_redirect"
  | "client_login_click"
  | "contact_form_submit"
  | "consultation_form_submit"
  | "email_plan_click"
  | "phone_click"
  | "email_click"
  | "faq_interaction"
  | "solution_selector_complete";

type EventPayload = Record<string, string | number | boolean | undefined>;

function dispatch(event: AnalyticsEvent, payload?: EventPayload) {
  const gaId = import.meta.env.VITE_GA_ID;
  const gtmId = import.meta.env.VITE_GTM_ID;

  if (typeof window === "undefined") return;

  // No IDs configured yet — no-op, but keep the call sites in place so
  // wiring up a real provider later is a one-file change.
  if (!gaId && !gtmId) {
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.debug("[analytics]", event, payload);
    }
    return;
  }

  const w = window as typeof window & { dataLayer?: unknown[] };
  w.dataLayer = w.dataLayer ?? [];
  w.dataLayer.push({ event, ...payload });
}

export const analytics = { track: dispatch };
